<template>
    <div style="padding:4px 0;">
        <label style="font-weight: bold;">
            {{ $t("models.attributes.core_waybills."+field_name) }}
        </label>

        <div
            class="ui mini fluid input"
            v-if="$parent.is_can_update_field(field_name)">
            <input
                type="text"
                v-if="input_type == 'text'"
                v-model="core_waybill[field_name]">
            <input
                type="number"
                v-if="input_type == 'number'"
                v-model="core_waybill[field_name]">
            <input
                type="email"
                v-else-if="input_type == 'email'"
                v-model="core_waybill[field_name]">
            <input
                type="tel"
                v-else-if="input_type == 'tel'"
                v-model="core_waybill[field_name]">
        </div>
        <div
            v-else
            class="ui message" style="margin: 0; padding: 6px 12px;">
            {{ core_waybill[field_name] || ((input_type == 'number') ? 0 : $t('ui.general.no_data')) }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        field_name: {
            default: "",
            type: String
        },
        input_type: {
            default: "text",
            type: String
        }
    },
    data() {
        return {
            is_grid_table_style: false,
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    },
    components: {
    },
}
</script>

<style scoped lang="scss">
</style>
